<template>
  <v-container fluid class="pa-0">
    <v-row justify="space-around" class="my-10">
      <v-col cols="10">
        <terms-and-conditions></terms-and-conditions>
      </v-col>
    </v-row>

    <Footer></Footer>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";

@Component({
  components: {
    Footer,
    TermsAndConditions,
  },
})
export default class PrivacyPolicyView extends Vue {}
</script>
